document.addEventListener('alpine:init', () => {
    Alpine.data('addRemove', () => ({
        count: '1',
        fields: [],
        addNewField() {
            this.fields.push({ id: new Date().getTime() + this.fields.length })
            this.count++
        },
        removeField(field) {
            this.fields.splice(this.fields.indexOf(field), 1)
            this.count--
        },
    }))
})
